/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedSkillListList } from '../model/paginatedSkillListList';
import { SkillList } from '../model/skillList';
import { SkillLookup } from '../model/skillLookup';
import { SkillStats } from '../model/skillStats';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioSkillsListService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * ViewSet for listing and filtering skills with comprehensive filtering options.  Ordering fields: title, subarea__parent__name, subarea__name, touch_count, default_priority  Available filters: - is_watched: Boolean filter for watched status - level: Filter by specific level (1, 2, or 3) - must be used with level_state - level_state: Filter by state at specific level (completed, watched, waiting) - state: Legacy state filter (finished, watched, waiting) - for backward compatibility - first_level_done, second_level_done, third_level_done: Legacy level filters - exclude_no_touches: Exclude skills with no touches  Watched Logic: - A skill is \&quot;watched\&quot; at a specific level if it&#x27;s the first unfinished level - Level 1 watched: skill is watched AND level 1 not completed - Level 2 watched: skill is watched AND level 1 completed AND level 2 not completed - Level 3 watched: skill is watched AND levels 1&amp;2 completed AND level 3 not completed  Waiting Logic: - A skill is \&quot;waiting\&quot; at a level if it&#x27;s not watched at that level and not completed  Ordering Logic: - Default ordering (no level filter): By level with non-finished first, then watched, then completed   Priority: L1 non-finished, L1 watched, L1 completed, L2 non-finished, L2 watched, L2 completed, etc. - Level-specific ordering (with level + level_state filter):   1. Skills matching the searched state at the specified level (highest priority)   2. Watched skills at the specified level   3. Completed skills at lower levels   4. Other skills by title  Level-Specific Stats: - When filtering by level and level_state, stats show counts for all states at that level:   - finished_count: Skills completed at the specified level   - watch_count: Skills watched at the specified level   - rest_count: Skills waiting at the specified level   - total_count: Sum of all skills that can be at the specified level
     * @param areaUuids Více hodnot lze oddělit čárkami.
     * @param childUuid UUID of the child
     * @param excludeNoTouches No Touches
     * @param firstLevelDone First Level Done
     * @param groupUuid UUID of the group
     * @param isWatched Filter by watched status
     * @param level Filter by specific level (1, 2, or 3). Use with level_state.
     * @param levelState Filter by level-specific state. Requires level parameter.
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param secondLevelDone Second Level Done
     * @param state * &#x60;finished&#x60; - Dokončeno * &#x60;completed&#x60; - Dokončeno 2 * &#x60;watched&#x60; - Sledováno * &#x60;waiting&#x60; - Čekající * &#x60;all&#x60; - Vše
     * @param subareaParentUuid 
     * @param subareaUuid 
     * @param subareaUuids Více hodnot lze oddělit čárkami.
     * @param thirdLevelDone Third Level Done
     * @param touchesDateFrom 
     * @param touchesDateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillsList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, limit?: number, offset?: number, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedSkillListList>;
    public childPortfolioSkillsList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, limit?: number, offset?: number, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedSkillListList>>;
    public childPortfolioSkillsList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, limit?: number, offset?: number, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedSkillListList>>;
    public childPortfolioSkillsList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, limit?: number, offset?: number, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (areaUuids) {
            queryParameters = queryParameters.set('area_uuids', areaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (excludeNoTouches !== undefined && excludeNoTouches !== null) {
            queryParameters = queryParameters.set('exclude_no_touches', <any>excludeNoTouches);
        }
        if (firstLevelDone !== undefined && firstLevelDone !== null) {
            queryParameters = queryParameters.set('first_level_done', <any>firstLevelDone);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isWatched !== undefined && isWatched !== null) {
            queryParameters = queryParameters.set('is_watched', <any>isWatched);
        }
        if (level !== undefined && level !== null) {
            queryParameters = queryParameters.set('level', <any>level);
        }
        if (levelState !== undefined && levelState !== null) {
            queryParameters = queryParameters.set('level_state', <any>levelState);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (secondLevelDone !== undefined && secondLevelDone !== null) {
            queryParameters = queryParameters.set('second_level_done', <any>secondLevelDone);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (subareaParentUuid !== undefined && subareaParentUuid !== null) {
            queryParameters = queryParameters.set('subarea__parent__uuid', <any>subareaParentUuid);
        }
        if (subareaUuid !== undefined && subareaUuid !== null) {
            queryParameters = queryParameters.set('subarea__uuid', <any>subareaUuid);
        }
        if (subareaUuids) {
            queryParameters = queryParameters.set('subarea_uuids', subareaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (thirdLevelDone !== undefined && thirdLevelDone !== null) {
            queryParameters = queryParameters.set('third_level_done', <any>thirdLevelDone);
        }
        if (touchesDateFrom !== undefined && touchesDateFrom !== null) {
            queryParameters = queryParameters.set('touches_date_from', <any>touchesDateFrom);
        }
        if (touchesDateTo !== undefined && touchesDateTo !== null) {
            queryParameters = queryParameters.set('touches_date_to', <any>touchesDateTo);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedSkillListList>('get',`${this.basePath}/child-portfolio/skills/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for listing and filtering skills with comprehensive filtering options.  Ordering fields: title, subarea__parent__name, subarea__name, touch_count, default_priority  Available filters: - is_watched: Boolean filter for watched status - level: Filter by specific level (1, 2, or 3) - must be used with level_state - level_state: Filter by state at specific level (completed, watched, waiting) - state: Legacy state filter (finished, watched, waiting) - for backward compatibility - first_level_done, second_level_done, third_level_done: Legacy level filters - exclude_no_touches: Exclude skills with no touches  Watched Logic: - A skill is \&quot;watched\&quot; at a specific level if it&#x27;s the first unfinished level - Level 1 watched: skill is watched AND level 1 not completed - Level 2 watched: skill is watched AND level 1 completed AND level 2 not completed - Level 3 watched: skill is watched AND levels 1&amp;2 completed AND level 3 not completed  Waiting Logic: - A skill is \&quot;waiting\&quot; at a level if it&#x27;s not watched at that level and not completed  Ordering Logic: - Default ordering (no level filter): By level with non-finished first, then watched, then completed   Priority: L1 non-finished, L1 watched, L1 completed, L2 non-finished, L2 watched, L2 completed, etc. - Level-specific ordering (with level + level_state filter):   1. Skills matching the searched state at the specified level (highest priority)   2. Watched skills at the specified level   3. Completed skills at lower levels   4. Other skills by title  Level-Specific Stats: - When filtering by level and level_state, stats show counts for all states at that level:   - finished_count: Skills completed at the specified level   - watch_count: Skills watched at the specified level   - rest_count: Skills waiting at the specified level   - total_count: Sum of all skills that can be at the specified level
     * @param areaUuids Více hodnot lze oddělit čárkami.
     * @param childUuid UUID of the child
     * @param excludeNoTouches No Touches
     * @param firstLevelDone First Level Done
     * @param groupUuid UUID of the group
     * @param isWatched Is Watched
     * @param level Level  * &#x60;1&#x60; - Level 1 * &#x60;2&#x60; - Level 2 * &#x60;3&#x60; - Level 3
     * @param levelState Level State  * &#x60;completed&#x60; - Completed * &#x60;watched&#x60; - Watched * &#x60;waiting&#x60; - Waiting
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param secondLevelDone Second Level Done
     * @param state * &#x60;finished&#x60; - Dokončeno * &#x60;completed&#x60; - Dokončeno 2 * &#x60;watched&#x60; - Sledováno * &#x60;waiting&#x60; - Čekající * &#x60;all&#x60; - Vše
     * @param subareaParentUuid 
     * @param subareaUuid 
     * @param subareaUuids Více hodnot lze oddělit čárkami.
     * @param thirdLevelDone Third Level Done
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillsLookupList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<SkillLookup>>;
    public childPortfolioSkillsLookupList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SkillLookup>>>;
    public childPortfolioSkillsLookupList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SkillLookup>>>;
    public childPortfolioSkillsLookupList(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (areaUuids) {
            queryParameters = queryParameters.set('area_uuids', areaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (excludeNoTouches !== undefined && excludeNoTouches !== null) {
            queryParameters = queryParameters.set('exclude_no_touches', <any>excludeNoTouches);
        }
        if (firstLevelDone !== undefined && firstLevelDone !== null) {
            queryParameters = queryParameters.set('first_level_done', <any>firstLevelDone);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isWatched !== undefined && isWatched !== null) {
            queryParameters = queryParameters.set('is_watched', <any>isWatched);
        }
        if (level !== undefined && level !== null) {
            queryParameters = queryParameters.set('level', <any>level);
        }
        if (levelState !== undefined && levelState !== null) {
            queryParameters = queryParameters.set('level_state', <any>levelState);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (secondLevelDone !== undefined && secondLevelDone !== null) {
            queryParameters = queryParameters.set('second_level_done', <any>secondLevelDone);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (subareaParentUuid !== undefined && subareaParentUuid !== null) {
            queryParameters = queryParameters.set('subarea__parent__uuid', <any>subareaParentUuid);
        }
        if (subareaUuid !== undefined && subareaUuid !== null) {
            queryParameters = queryParameters.set('subarea__uuid', <any>subareaUuid);
        }
        if (subareaUuids) {
            queryParameters = queryParameters.set('subarea_uuids', subareaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (thirdLevelDone !== undefined && thirdLevelDone !== null) {
            queryParameters = queryParameters.set('third_level_done', <any>thirdLevelDone);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SkillLookup>>('get',`${this.basePath}/child-portfolio/skills/lookup/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Return all skills for child or group as Excel file.
     * @param areaUuids Více hodnot lze oddělit čárkami.
     * @param childUuid UUID of the child
     * @param excludeNoTouches No Touches
     * @param firstLevelDone First Level Done
     * @param groupUuid UUID of the group
     * @param isWatched Is Watched
     * @param level Level  * &#x60;1&#x60; - Level 1 * &#x60;2&#x60; - Level 2 * &#x60;3&#x60; - Level 3
     * @param levelState Level State  * &#x60;completed&#x60; - Completed * &#x60;watched&#x60; - Watched * &#x60;waiting&#x60; - Waiting
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param secondLevelDone Second Level Done
     * @param state * &#x60;finished&#x60; - Dokončeno * &#x60;completed&#x60; - Dokončeno 2 * &#x60;watched&#x60; - Sledováno * &#x60;waiting&#x60; - Čekající * &#x60;all&#x60; - Vše
     * @param subareaParentUuid 
     * @param subareaUuid 
     * @param subareaUuids Více hodnot lze oddělit čárkami.
     * @param thirdLevelDone Third Level Done
     * @param type Export type: &#x27;csv&#x27; or &#x27;xlsx&#x27;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillsPrintRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, type?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public childPortfolioSkillsPrintRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, type?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public childPortfolioSkillsPrintRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, type?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public childPortfolioSkillsPrintRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, ordering?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, type?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (areaUuids) {
            queryParameters = queryParameters.set('area_uuids', areaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (excludeNoTouches !== undefined && excludeNoTouches !== null) {
            queryParameters = queryParameters.set('exclude_no_touches', <any>excludeNoTouches);
        }
        if (firstLevelDone !== undefined && firstLevelDone !== null) {
            queryParameters = queryParameters.set('first_level_done', <any>firstLevelDone);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isWatched !== undefined && isWatched !== null) {
            queryParameters = queryParameters.set('is_watched', <any>isWatched);
        }
        if (level !== undefined && level !== null) {
            queryParameters = queryParameters.set('level', <any>level);
        }
        if (levelState !== undefined && levelState !== null) {
            queryParameters = queryParameters.set('level_state', <any>levelState);
        }
        if (ordering !== undefined && ordering !== null) {
            queryParameters = queryParameters.set('ordering', <any>ordering);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (secondLevelDone !== undefined && secondLevelDone !== null) {
            queryParameters = queryParameters.set('second_level_done', <any>secondLevelDone);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (subareaParentUuid !== undefined && subareaParentUuid !== null) {
            queryParameters = queryParameters.set('subarea__parent__uuid', <any>subareaParentUuid);
        }
        if (subareaUuid !== undefined && subareaUuid !== null) {
            queryParameters = queryParameters.set('subarea__uuid', <any>subareaUuid);
        }
        if (subareaUuids) {
            queryParameters = queryParameters.set('subarea_uuids', subareaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (thirdLevelDone !== undefined && thirdLevelDone !== null) {
            queryParameters = queryParameters.set('third_level_done', <any>thirdLevelDone);
        }
        if (type !== undefined && type !== null) {
            queryParameters = queryParameters.set('type', <any>type);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/child-portfolio/skills/print/`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for listing and filtering skills with comprehensive filtering options.  Ordering fields: title, subarea__parent__name, subarea__name, touch_count, default_priority  Available filters: - is_watched: Boolean filter for watched status - level: Filter by specific level (1, 2, or 3) - must be used with level_state - level_state: Filter by state at specific level (completed, watched, waiting) - state: Legacy state filter (finished, watched, waiting) - for backward compatibility - first_level_done, second_level_done, third_level_done: Legacy level filters - exclude_no_touches: Exclude skills with no touches  Watched Logic: - A skill is \&quot;watched\&quot; at a specific level if it&#x27;s the first unfinished level - Level 1 watched: skill is watched AND level 1 not completed - Level 2 watched: skill is watched AND level 1 completed AND level 2 not completed - Level 3 watched: skill is watched AND levels 1&amp;2 completed AND level 3 not completed  Waiting Logic: - A skill is \&quot;waiting\&quot; at a level if it&#x27;s not watched at that level and not completed  Ordering Logic: - Default ordering (no level filter): By level with non-finished first, then watched, then completed   Priority: L1 non-finished, L1 watched, L1 completed, L2 non-finished, L2 watched, L2 completed, etc. - Level-specific ordering (with level + level_state filter):   1. Skills matching the searched state at the specified level (highest priority)   2. Watched skills at the specified level   3. Completed skills at lower levels   4. Other skills by title  Level-Specific Stats: - When filtering by level and level_state, stats show counts for all states at that level:   - finished_count: Skills completed at the specified level   - watch_count: Skills watched at the specified level   - rest_count: Skills waiting at the specified level   - total_count: Sum of all skills that can be at the specified level
     * @param id A UUID string identifying this Dovednost.
     * @param childUuid UUID of the child
     * @param groupUuid UUID of the group
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillsRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<SkillList>;
    public childPortfolioSkillsRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SkillList>>;
    public childPortfolioSkillsRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SkillList>>;
    public childPortfolioSkillsRetrieve(id: string, childUuid?: Array<string>, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling childPortfolioSkillsRetrieve.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SkillList>('get',`${this.basePath}/child-portfolio/skills/${encodeURIComponent(String(id))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * ViewSet for listing and filtering skills with comprehensive filtering options.  Ordering fields: title, subarea__parent__name, subarea__name, touch_count, default_priority  Available filters: - is_watched: Boolean filter for watched status - level: Filter by specific level (1, 2, or 3) - must be used with level_state - level_state: Filter by state at specific level (completed, watched, waiting) - state: Legacy state filter (finished, watched, waiting) - for backward compatibility - first_level_done, second_level_done, third_level_done: Legacy level filters - exclude_no_touches: Exclude skills with no touches  Watched Logic: - A skill is \&quot;watched\&quot; at a specific level if it&#x27;s the first unfinished level - Level 1 watched: skill is watched AND level 1 not completed - Level 2 watched: skill is watched AND level 1 completed AND level 2 not completed - Level 3 watched: skill is watched AND levels 1&amp;2 completed AND level 3 not completed  Waiting Logic: - A skill is \&quot;waiting\&quot; at a level if it&#x27;s not watched at that level and not completed  Ordering Logic: - Default ordering (no level filter): By level with non-finished first, then watched, then completed   Priority: L1 non-finished, L1 watched, L1 completed, L2 non-finished, L2 watched, L2 completed, etc. - Level-specific ordering (with level + level_state filter):   1. Skills matching the searched state at the specified level (highest priority)   2. Watched skills at the specified level   3. Completed skills at lower levels   4. Other skills by title  Level-Specific Stats: - When filtering by level and level_state, stats show counts for all states at that level:   - finished_count: Skills completed at the specified level   - watch_count: Skills watched at the specified level   - rest_count: Skills waiting at the specified level   - total_count: Sum of all skills that can be at the specified level
     * @param areaUuids Více hodnot lze oddělit čárkami.
     * @param childUuid UUID of the child
     * @param excludeNoTouches No Touches
     * @param firstLevelDone First Level Done
     * @param groupUuid UUID of the group
     * @param isWatched Filter by watched status
     * @param level Filter by specific level (1, 2, or 3). Use with level_state.
     * @param levelState Filter by level-specific state. Requires level parameter.
     * @param search A search term.
     * @param secondLevelDone Second Level Done
     * @param state * &#x60;finished&#x60; - Dokončeno * &#x60;completed&#x60; - Dokončeno 2 * &#x60;watched&#x60; - Sledováno * &#x60;waiting&#x60; - Čekající * &#x60;all&#x60; - Vše
     * @param subareaParentUuid 
     * @param subareaUuid 
     * @param subareaUuids Více hodnot lze oddělit čárkami.
     * @param thirdLevelDone Third Level Done
     * @param touchesDateFrom 
     * @param touchesDateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioSkillsStatsRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'body', reportProgress?: boolean): Observable<SkillStats>;
    public childPortfolioSkillsStatsRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SkillStats>>;
    public childPortfolioSkillsStatsRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SkillStats>>;
    public childPortfolioSkillsStatsRetrieve(areaUuids?: Array<string>, childUuid?: Array<string>, excludeNoTouches?: boolean, firstLevelDone?: boolean, groupUuid?: string, isWatched?: boolean, level?: number, levelState?: string, search?: string, secondLevelDone?: boolean, state?: string, subareaParentUuid?: string, subareaUuid?: string, subareaUuids?: Array<string>, thirdLevelDone?: boolean, touchesDateFrom?: string, touchesDateTo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


















        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (areaUuids) {
            queryParameters = queryParameters.set('area_uuids', areaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (excludeNoTouches !== undefined && excludeNoTouches !== null) {
            queryParameters = queryParameters.set('exclude_no_touches', <any>excludeNoTouches);
        }
        if (firstLevelDone !== undefined && firstLevelDone !== null) {
            queryParameters = queryParameters.set('first_level_done', <any>firstLevelDone);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }
        if (isWatched !== undefined && isWatched !== null) {
            queryParameters = queryParameters.set('is_watched', <any>isWatched);
        }
        if (level !== undefined && level !== null) {
            queryParameters = queryParameters.set('level', <any>level);
        }
        if (levelState !== undefined && levelState !== null) {
            queryParameters = queryParameters.set('level_state', <any>levelState);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (secondLevelDone !== undefined && secondLevelDone !== null) {
            queryParameters = queryParameters.set('second_level_done', <any>secondLevelDone);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }
        if (subareaParentUuid !== undefined && subareaParentUuid !== null) {
            queryParameters = queryParameters.set('subarea__parent__uuid', <any>subareaParentUuid);
        }
        if (subareaUuid !== undefined && subareaUuid !== null) {
            queryParameters = queryParameters.set('subarea__uuid', <any>subareaUuid);
        }
        if (subareaUuids) {
            queryParameters = queryParameters.set('subarea_uuids', subareaUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (thirdLevelDone !== undefined && thirdLevelDone !== null) {
            queryParameters = queryParameters.set('third_level_done', <any>thirdLevelDone);
        }
        if (touchesDateFrom !== undefined && touchesDateFrom !== null) {
            queryParameters = queryParameters.set('touches_date_from', <any>touchesDateFrom);
        }
        if (touchesDateTo !== undefined && touchesDateTo !== null) {
            queryParameters = queryParameters.set('touches_date_to', <any>touchesDateTo);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SkillStats>('get',`${this.basePath}/child-portfolio/skills/stats/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
